import axios from "axios";

export default {
	data: () => ({
		startTime: "",
		executionTime: "",
		currentStep: ""
	}),

	methods: {
		startTimeLog(step) {
			this.startTime = window.performance.now()
			this.currentStep = step
		},

		endTimeLog(data) {
			this.setExecutionTime()

			this.logRequest(data)
		},

		setExecutionTime() {
			this.executionTime = ((window.performance.now() - this.startTime) / 1000.0).toFixed(4);
		},

		logRequest(data) {
			try {
				data['duration'] = this.executionTime;
				data['step'] = this.currentStep;

				axios.post('/api/timelog', data);
			} catch (e) {
				console.error("Log were not save", e);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./resources/js/mixins/requestLogging.js